<template>
    <div id="exchangeVipCard">
        <Headers :headersText='headersText'></Headers>
        <!-- 兑换 -->
        <div class="exchangeBox">
            <input type="text" placeholder="输入您优酷视频绑定的手机号码" v-model="telPhoneNum" id="telPhoneNum">
            <div class="balance">
                <div class="title">您的余额</div>
                <div class="balanceNum">43.32<span>元</span></div>
            </div>
            <div class="lines"></div>
            <div class="spend">
                <div class="title">本次花费</div>
                <div class="spendNum">{{price}}<span>元</span></div>
            </div>
        </div>
        <!-- 确认兑换按钮 -->
        <div class="boxPadding">
            <div class="btn" @click="confirmExchange">确认兑换</div>
        </div>

        <popup :pops='pops' @fatherMethod='fatherMethod' v-show="confirmExchanges"></popup>
    </div>
</template>

<script>
    // 引入弹窗
    import popup from '../components/Popup.vue'

    import Headers from '../components/headers'
    export default {
        components:{
            popup,
            Headers
        },
        data() {
            return {
                headersText:'兑换优酷视频会员',
                price:0, // 购买价格
                telPhoneNum:'', // 手机号码
                pops:{
                    icons:require('../assets/images/img_86.png'), //可选
                    iconWidth:50, // 可选（若有图片必填）
                    iconHeight:45, // 可选（若有图片必填）
                    iconMargin:'25px 0 8px',
                    tits1:'您已成功兑换会员 请及时查收', // 可选
                    // tits2:'快去分享给小伙伴吧', // 可选
                    // conts:'任务完成任务完成任务完成任务完成任务完成任务完成', // 可选
                    btns:'确定',
                    btnMarginTop:21
                },
                confirmExchanges:false
            }
        },
        created() {
            this.price = this.$route.query.price
        },
        methods: {
            // 确认兑换
            confirmExchange:function(){
                this.confirmExchanges = true;
            },
            fatherMethod:function(){
                this.confirmExchanges = false
                this.$router.go(-2);
            }
        },
    }
</script>

<style lang="less" scoped>
    #exchangeVipCard{
        // 兑换
        .exchangeBox{
            width:315px;
            height:225px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,1);
            padding: 15px;
            margin: 15px;
            display: flex;
            flex-direction: column;
            align-items: center;
            #telPhoneNum{
                width:275px;
                height:50px;
                background:rgba(242,242,242,1);
                border-radius:5px;
                font-size: 15px;
                border: none;
                text-align: center;
                padding: 0 20px;
                &:focus{
                    outline:none;
                }
            }
            .balance{
                text-align: center;
                .title{
                    font-size:13px;
                    font-weight:400;
                    color:rgba(21,21,21,.6);
                    line-height:18px;
                    margin: 25px 0 7px;
                }
                .balanceNum{
                    font-size:25px;
                    font-family: "Qds";
                    color:rgba(21,21,21,1);
                    line-height:25px;
                    font-weight: bold;
                    span{
                        font-size: 13px;
                        color: #151515; 
                    }
                }
            }
            .lines{
                width:315px;
                height:1px;
                background:rgba(229,229,229,1);
                margin: 25px 0 15px;
            }
            .spend{
                text-align: center;
                .title{
                    font-size:13px;
                    font-weight:400;
                    color:rgba(21,21,21,.6);
                    line-height:18px;
                }
                .spendNum{
                    font-size:25px;
                    font-family: "Qds";
                    color:rgba(229,1,19,1);
                    line-height:25px;
                    font-weight: bold;
                    margin: 7px 0 9px;   
                    span{
                        font-size: 13px;
                        color: #151515;
                    }
                }
            }
        }
        // 确认兑换按钮
        .boxPadding{
            padding-bottom: 15px;
            .btn{
                width:335px;
                height:50px;
                background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
                border-radius:25px;
                font-size:15px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:50px;
                text-align: center;
                margin: 63px 20px 0;
            }
        }
    }
</style>